import { render } from "./ProductHeaderMenu.vue?vue&type=template&id=39067451&scoped=true"
import script from "./ProductHeaderMenu.vue?vue&type=script&lang=js"
export * from "./ProductHeaderMenu.vue?vue&type=script&lang=js"

import "./ProductHeaderMenu.vue?vue&type=style&index=0&id=39067451&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39067451"]])

export default __exports__